import * as routes from 'src/app/onboarding/routes';
import { navigateTo } from 'src/lib/navigateTo';

export const goLogout = (params: { callbackUrl?: string } = {}) => {
  navigateTo(routes.logoutRouteConfig.path(params));
};
